import React from 'react'
export const messageHandler = (
    data,
    product,
    user,
    setAlert,
    setViewProduct,
    type,
    noBadge = false,
) => {
    let user_id = user.id
    const index = product.findIndex((s) => s.id === parseInt(data.id || data.product_id, 10))
    let productToChange = product[index]
    if (index !== -1) {
        if (type === 'realclosedupdates') {
            if (data.usr !== '') {
                if (user_id === parseInt(data.bpop_cbidder)) {
                    product[index] = {
                        ...productToChange,
                        market_status: 'sold',
                        bidtopstatus: 'won',
                        buynowamount: data.buynowamount,
                        cbidtext: 'Sold Price',
                    }
                    setViewProduct([...product])
                } else if (parseInt(productToChange.bid_or_not) > 0) {
                    product[index] = {
                        ...productToChange,
                        market_status: 'sold',
                        bidtopstatus: 'lost',
                        buynowamount: data.buynowamount,
                        cbidtext: 'Sold Price',
                    }
                    setViewProduct([...product])
                } else {
                    product[index] = {
                        ...productToChange,
                        market_status: 'sold',
                        buynowamount: data.buynowamount,
                        cbidtext: 'Sold Price',
                    }
                    setViewProduct([...product])
                }
            } else {
                if (parseInt(productToChange.bid_or_not) > 0) {
                    product[index] = {
                        ...productToChange,
                        market_status: 'closed',
                        bidtopstatus: 'lost',
                    }
                    setViewProduct([...product])
                } else {
                    product[index] = {
                        ...productToChange,
                        market_status: 'closed',
                    }
                    setViewProduct([...product])
                }
            }
        } else if (type === 'bidAddtime') {
            if (parseInt(data.bpop_belowFive) === 1) {
                // updatecloseDate(data.bpop_belowFiveIncrement)
            }
            if (data.status === 'failed' && user_id === parseInt(data.bpop_cbidder)) {
                setAlert(data.error, 'error')
            }
            if (data.status !== 'failed') {
                if (parseInt(data.bpop_belowFive) === 1) {
                    productToChange.date_closed = data.bpop_belowFiveIncrement
                }
                if (user_id === parseInt(data.bpop_cbidder)) {
                    setAlert(
                        phrase['bid_placed_successfully'] || 'Bid placed successfully',
                        'success',
                    )
                    product[index] = {
                        ...productToChange,
                        next_bid: data.bpop_cuser_nextbid,
                        wprice: data.bpop_wprice,
                        bidtopstatus: data.bpop_bidstatus,
                        bid_count: data.bpop_bidcount,
                        bid_or_not: 1,
                        cbidtext: 'Current Bid',
                        latestbid: data.bpop_wprice,
                    }
                    setViewProduct([...product])
                } else {
                    if (parseInt(productToChange.bid_or_not) > 0) {
                        if (user_id === parseInt(data.bpop_higher)) {
                            if (parseInt(productToChange.next_bid) < parseInt(data.bpop_nextbid)) {
                                product[index] = {
                                    ...productToChange,
                                    next_bid: data.bpop_nextbid_org,
                                    wprice: data.bpop_wprice,
                                    bidtopstatus: noBadge ? '' : 'winner',
                                    bid_count: data.bpop_bidcount,
                                    latestbid: data.bpop_wprice,
                                }
                                setViewProduct([...product])
                            } else {
                                product[index] = {
                                    ...productToChange,
                                    wprice: data.bpop_wprice,
                                    bidtopstatus: noBadge ? '' : 'winner',
                                    bid_count: data.bpop_bidcount,
                                    latestbid: data.bpop_wprice,
                                }
                                setViewProduct([...product])
                            }
                        } else {
                            product[index] = {
                                ...productToChange,
                                next_bid: data.bpop_nextbid_org,
                                wprice: data.bpop_wprice,
                                bid_count: data.bpop_bidcount,
                                bidtopstatus: noBadge ? '' : 'outbid',
                                bid_or_not: 1,
                                latestbid: data.bpop_wprice,
                            }
                            setViewProduct([...product])
                        }
                    } else {
                        product[index] = {
                            ...productToChange,
                            next_bid: data.bpop_nextbid_org,
                            wprice: data.bpop_wprice,
                            bid_count: data.bpop_bidcount,
                            cbidtext: 'Current Bid',
                            latestbid: data.bpop_wprice,
                        }
                        setViewProduct([...product])
                    }
                }
                // getBidHistoryProduct({ product_id: project_id })
            }
        } else if (type === 'bid_extended') {
            product[index] = {
                ...productToChange,
                date_closed: data.date_extended,
            }
            setViewProduct([...product])
        } else if (type === 'watchlistAdded') {
            product[index] = {
                ...productToChange,
                watchlistid: data.status === 'added' ? 1 : 0,
            }
            setViewProduct([...product])
        } else if (type === 'drop_price') {
            product[index] = {
                ...productToChange,
                sprice: data.sprice,
                wprice: data.sprice,
            }
            setViewProduct([...product])
        }
    }
}

// bid socket handler for live / blind (SINGLE) auction
export const bidSocketHandler = (data, type, user, product, phrase, setProduct, setAlert) => {
    let productToChange = { ...product }
    const parseSocketAmount = (value) => {
        if (value === undefined || value === null || value === '') return NaN
        const normalizedValue = `${value}`.replace(/,/g, '').replace(/[^\d.-]/g, '')
        if (
            !normalizedValue ||
            normalizedValue === '-' ||
            normalizedValue === '.' ||
            normalizedValue === '-.'
        )
            return NaN
        return parseFloat(normalizedValue)
    }
    const getReserveStatusMessage = (bidValue = productToChange.wprice) => {
        const reservePrice = parseSocketAmount(productToChange.rprice)
        const currentBid = parseSocketAmount(bidValue)
        const reserveNotMetPhrase = phrase.reserve_price_is_not_met || 'Reserve price is not met'
        if (Number.isNaN(reservePrice) || Number.isNaN(currentBid)) {
            return reserveNotMetPhrase
        }
        return currentBid >= reservePrice
            ? phrase.reserve_price_is_met || 'Reserve price is met'
            : reserveNotMetPhrase
    }
    // AUCTION CLOSE
    if (type === 'realclosedupdates') {
        if (data.pid == product.id) {
            const bidCandidates = [
                parseSocketAmount(data.current_bid),
                parseSocketAmount(data.wprice),
                parseSocketAmount(data.buynowamount),
            ]
            const positiveSocketBid = bidCandidates.find(
                (value) => !Number.isNaN(value) && value > 0,
            )
            const fallbackSocketBid = bidCandidates.find((value) => !Number.isNaN(value))
            const currentProductBid = parseSocketAmount(productToChange.wprice)
            const canOverrideWithFallback =
                (Number.isNaN(currentProductBid) || currentProductBid <= 0) &&
                fallbackSocketBid !== undefined

            if (positiveSocketBid !== undefined) {
                productToChange.wprice = positiveSocketBid
            } else if (canOverrideWithFallback) {
                productToChange.wprice = fallbackSocketBid
            }
            if (data.currency) {
                productToChange.currency = data.currency
            }
            if (data.currency_symbol) {
                productToChange.currency_symbol = data.currency_symbol
            }
            // This Item was awarded to somebody
            if (data.usr != '') {
                if (data.status === 'pending' && data.usr == user.id) {
                    productToChange.market_status = 'pending'
                    productToChange.bidMessage = `<div class="padboth primeColor">${phrase.auction_closed_under_review}</div>`

                    productToChange.bottomBidMessage =
                        '<div><div><span class="primeColor padboth" style="font-size: 14px; font-weight: 900; letter-spacing: 1px;">' +
                        `${phrase.reserve_price_is_not_met || 'Reserve price is not met'}` +
                        '</span></div></div>'

                    setProduct(productToChange)
                    return
                }
                productToChange.market_status = 'sold'
                const reserveStatusMessage = getReserveStatusMessage()
                productToChange.bottomBidMessage =
                    '<div  class="padboth primeColor" style="font-size: 14px;font-weight: 900;letter-spacing: 1px;">' +
                    `${reserveStatusMessage}` +
                    '</div>'
                // This User or Company won the item
                if (
                    data.usr == user.id ||
                    (user.companyid == data.cid &&
                        data.cid &&
                        data.cid != '' &&
                        data.cid != '0' &&
                        user.companyid &&
                        user.companyid != '' &&
                        user.companyid != '0')
                ) {
                    productToChange.bidMessage = `<div class="padboth primeColor"> ${phrase.congratulations_you_have} <strong>${phrase.won}</strong> ${phrase.this_item} </div>`
                    setProduct(productToChange)
                }
                // This User or Company did not win the item
                else {
                    // This User or Company has bid on this item, but did not win=> Show Message
                    if (
                        parseInt(productToChange.userHasBid) > 0 ||
                        parseInt(productToChange.companyHasBid)
                    ) {
                        productToChange.bidMessage = `<div class="padboth" style="color: red;"> ${phrase.unfortunately_you} <strong>${phrase.lost}</strong> ${phrase.this_item} </div>`
                        setProduct(productToChange)
                    } else {
                        setProduct(productToChange)
                    }
                }
            }
            // no users were awarded
            else {
                productToChange.bottomBidMessage = ''
                productToChange.topBidMessage = ''
                // This User or Company has bid on this item => Show Message
                if (
                    parseInt(productToChange.userHasBid) > 0 ||
                    parseInt(productToChange.companyHasBid)
                ) {
                    productToChange.market_status = 'closed'
                    productToChange.bidMessage = `<div class="padboth" style="color: red;"> ${phrase.unfortunately_you} <strong>${phrase.lost}</strong> ${phrase.this_item} </div>`
                    setProduct(productToChange)
                } else {
                    productToChange.market_status = 'closed'
                    setProduct(productToChange)
                }
            }
        }
    }
    // BID EVENT
    else if (type === 'bidAddtime') {
        if (data.id == product.id) {
            // bid failed
            if (data.status === 'failed' && user.id === parseInt(data.bpop_cbidder)) {
                setAlert(data.error, 'error')
            }
            // bid success
            if (data.status !== 'failed') {
                if (parseInt(data.bpop_belowFive) === 1) {
                    productToChange.date_closed = data.bpop_belowFiveIncrement
                }
                // out bid message template
                productToChange.bid_count = data.bpop_bidcount
                let outbidMsg
                const isSealedAuction =
                    data.auctiontype == 'sealed' || productToChange.auctiontype == 'sealed'
                const socketBidStatusMessage = `${data.bpop_bidstatus || ''}`.trim()
                const resolveSealedBidMessage = (fallbackMessage) =>
                    socketBidStatusMessage || fallbackMessage
                if (isSealedAuction) {
                    // blind auction
                    const bidderNumberRaw = `${data.bidder_number ?? ''}`.trim()
                    const bidderNumberMatch = bidderNumberRaw.match(/\d+/)
                    const customerWord =
                        phrase.customer || phrase.customer_no || phrase.customer_label || 'Customer'
                    const bidderNumber = bidderNumberMatch
                        ? `${customerWord} ${bidderNumberMatch[0]}`
                        : customerWord
                    const losingPrefix =
                        phrase.youre_losing_this_item_customer || 'You are losing this item,'
                    const placedHigher = phrase.has_placed_a_higher || 'has placed a higher'
                    const bidText = phrase.bid || 'Bid'
                    const losingPrefixNormalized = `${losingPrefix}`.trim()
                    const customerWordNormalized = `${customerWord}`.trim().toLowerCase()
                    const prefixEndsWithCustomer = losingPrefixNormalized
                        .toLowerCase()
                        .endsWith(customerWordNormalized)
                    const bidderLabelForPrefix =
                        prefixEndsWithCustomer && bidderNumberMatch
                            ? bidderNumberMatch[0]
                            : bidderNumber
                    const sealedOutbidText = `${losingPrefix} ${bidderLabelForPrefix} ${placedHigher} ${bidText}`
                    outbidMsg = `<div style="color: red;">${sealedOutbidText}</div>`
                } else {
                    // live auction
                    outbidMsg = `<div style="color: red;"> ${phrase.youre_losing_this_item_customer} ${data.bidder_number} ${phrase.has_placed_a_higher} <strong>${phrase.bid}</strong>.</div>`
                }

                // highest bidder message template
                const highestBidderMsg = `<div class="primeColor" style="font-size: 15px;font-weight: 900; line-height:1.5"> ${phrase.youre_winning_this_item_at}  ${data.bpop_wprice} ${product.currency}. ${phrase.your_autobid_of}  ${data.bpop_wprice_morehigh} ${product.currency} ${phrase.has_been_placed_successfully}</div>`
                const sealedHighestBidderText =
                    phrase.you_are_highest_bidder ||
                    phrase.you_are_the_highest_bidder_on_this_item ||
                    phrase.youre_winning_this_item ||
                    phrase.highest_bidder ||
                    phrase.winning ||
                    'Highest bidder'
                const sealedHighestBidderMsg = `<div class="primeColor" style="font-size: 15px;font-weight: 900; line-height:1.5">${sealedHighestBidderText}</div>`
                const reserveStatusMessage = getReserveStatusMessage(data.bpop_wprice)
                const highestBidderMsgReserveStatus = `<div class="padboth primeColor" style="font-size: 15px;font-weight: 900; line-height:1.5">  ${phrase.youre_winning_this_item_at.toUpperCase()}  €${
                    data.bpop_wprice
                } <div  class="padboth primeColor" style="font-size: 22px;font-weight: 900;letter-spacing: 1px;">  ${reserveStatusMessage.toUpperCase()} </div>`

                const autobidMessReserveStatus = `<div class="padboth primeColor" style="font-weight: 900; font-size: 14px"> ${phrase.your_autobid_of} <span class="hvpop"> €<font class="formatCurrency">${data.bpop_wprice_morehigh}</font> ${phrase.has_been_placed_successfully} </span></div>
                <div class="padboth primeColor" style="font-weight: 900">${reserveStatusMessage}</div>`
                // This user just bid on the item
                if (user.id === parseInt(data.bpop_cbidder)) {
                    setAlert(
                        phrase['bid_placed_successfully'] || 'Bid placed successfully',
                        'success',
                    )
                    productToChange.next_bid = data.bpop_cuser_nextbid
                    productToChange.wprice = data.bpop_wprice
                    productToChange.buyerPrice = data.cuser_enteramount
                    if (data.bottomBidMessage != ' ' && data.topBidMessage != ' ') {
                        productToChange.bottomBidMessage = data.bottomBidMessage
                        productToChange.topBidMessage = data.topBidMessage
                    } else if (data.bpop_higher == user.id) {
                        productToChange.bottomBidMessage = autobidMessReserveStatus
                        productToChange.topBidMessage = highestBidderMsgReserveStatus
                    }
                    if (data.auctiontype == 'live') {
                        productToChange.bidMessage = data.bpop_bidstatus
                    } else {
                        if (user.id === parseInt(data.bpop_higher)) {
                            productToChange.bidMessage =
                                resolveSealedBidMessage(sealedHighestBidderMsg)
                            productToChange.topBidMessage = ''
                            productToChange.bottomBidMessage = ''
                        } else {
                            productToChange.bidMessage = outbidMsg
                        }
                    }
                    productToChange.userHasBid = 1
                    productToChange.cbidtext = 'Current Bid'
                    if (data.auctiontype == 'sealed')
                        productToChange.blindIncrementVal = data.bpop_cuser_increment
                    setProduct(productToChange)
                }
                // Other user bid
                else {
                    // This user has a bid in this item
                    if (parseInt(productToChange.userHasBid) > 0) {
                        // other user has bid, but this user is still the highest
                        if (user.id === parseInt(data.bpop_higher)) {
                            // LIVE AUCTION
                            // This user's autobid was placed and is still the highest.
                            // But, this user's max amount has been reached.
                            if (data.auctiontype == 'live') {
                                if (
                                    parseInt(productToChange.next_bid) < parseInt(data.bpop_nextbid)
                                ) {
                                    productToChange.next_bid = data.bpop_nextbid_org
                                    productToChange.wprice = data.bpop_wprice
                                    productToChange.bidMessage = highestBidderMsg
                                    setProduct(productToChange)
                                } else {
                                    // This user's autobid was placed
                                    productToChange.wprice = data.bpop_wprice
                                    productToChange.bidMessage = highestBidderMsg
                                    productToChange.bottomBidMessage = autobidMessReserveStatus
                                    productToChange.topBidMessage = highestBidderMsgReserveStatus
                                    setProduct(productToChange)
                                }
                            } else {
                                productToChange.wprice = data.bpop_wprice
                                productToChange.bidMessage =
                                    resolveSealedBidMessage(sealedHighestBidderMsg)
                                productToChange.topBidMessage = ''
                                productToChange.bottomBidMessage = ''
                                setProduct(productToChange)
                            }
                        }
                        // This user is outbid
                        else {
                            // LIVE AUCTION
                            if (data.auctiontype == 'live') {
                                productToChange.next_bid = data.bpop_nextbid_org
                                productToChange.wprice = data.bpop_wprice
                                productToChange.bidMessage = outbidMsg
                                productToChange.topBidMessage = outbidMsg
                                productToChange.bottomBidMessage = ''
                                setProduct(productToChange)
                            }
                            // BLIND AUCTION
                            else {
                                productToChange.next_bid = data.bpop_nextbid_org
                                productToChange.wprice = data.bpop_wprice
                                productToChange.bidMessage = outbidMsg
                                productToChange.topBidMessage = outbidMsg
                                productToChange.bottomBidMessage = ''
                                setProduct(productToChange)
                            }
                        }
                    } else {
                        // No bid for this user
                        if (data.bpop_nextbid_org) {
                            productToChange.next_bid = data.bpop_nextbid_org
                        }
                        if (data.auctiontype == 'sealed' && data.bpop_increment) {
                            productToChange.blindIncrementVal = data.bpop_increment
                        }
                        productToChange.wprice = data.bpop_wprice
                        setProduct(productToChange)
                    }
                }
            }
        }
    } else if (type === 'bid_extended') {
        if (data.product_id == product.id) {
            productToChange.date_closed = data.date_extended
            setProduct(productToChange)
        }
    } else if (type === 'drop_price') {
        if (data.id == product.id) {
            productToChange.sprice = data.sprice
            productToChange.wprice = data.sprice
            setProduct(productToChange)
        }
    }
    // RESERVE PRICE CHANGE
    else {
        if (data.id == product.id) {
            if (data.reserveprice) {
                const parsedReservePrice = parseSocketAmount(data.reserveprice)
                if (!Number.isNaN(parsedReservePrice)) {
                    productToChange.rprice = parsedReservePrice
                    setProduct(productToChange)
                }
            }
        }
    }
}

// bid socket handler for line item auction
export const lineItemBidSocketHandler = (
    data,
    type,
    user,
    lineItems,
    bulkBidLineItems,
    didBulkBid,
    setLineItems,
    setDwBidStatus,
    setBulkBidLineItems,
    setAlert,
    phrase,
    commonSubmitPendingSuccessAlerts,
    commonSubmitSuppressSuccessUntil,
) => {
    const parseLineItemSocketInteger = (value) => {
        const parsed = parseInt(
            String(value ?? '')
                .replace(/,/g, '')
                .trim(),
            10,
        )
        return Number.isNaN(parsed) ? null : parsed
    }
    const lineItemWinningMessage = `<div class='padboth' style="color: #28a745;"> ${phrase.winning} </div>`
    const lineItemHighestBidderMessage = `<div class='padboth' style="color: orange;"> ${phrase.highest_bidder} </div>`
    const lineItemLosingMessage = `<div class='padboth' style="color: red;"> ${phrase.losing} </div>`
    const applyLineItemBidCount = (lineItem) => {
        const socketBidCount = parseInt(data.bpop_bidcount, 10)
        if (!Number.isNaN(socketBidCount) && socketBidCount >= 0) {
            lineItem.bid_count = socketBidCount
            return
        }
        const currentBidCount = parseInt(lineItem.bid_count || 0, 10)
        lineItem.bid_count = Number.isNaN(currentBidCount) ? 1 : currentBidCount + 1
    }
    const isCompanyHighestBidder =
        user.companyid == data.bpop_highercompanyid &&
        data.bpop_highercompanyid &&
        data.bpop_highercompanyid != '' &&
        data.bpop_highercompanyid != '0' &&
        user.companyid &&
        user.companyid != '' &&
        user.companyid != '0'
    const isUserHighestBidder = data.bpop_higher == user.id || isCompanyHighestBidder

    // BID EVENT
    if (type == 'bidAddtime') {
        // check if this product is on the page,
        let lineItemIndex = lineItems.findIndex((p) => {
            return p.id === parseInt(data.id)
        })
        // This line item is on the screen
        if (lineItemIndex !== -1) {
            let lineItemsCopy = [...lineItems]
            // This User just bid
            if (
                data.bpop_cbidder == user.id ||
                (user.companyid == data.bpop_companyid &&
                    data.bpop_companyid &&
                    data.bpop_companyid != '' &&
                    data.bpop_companyid != '0' &&
                    user.companyid &&
                    user.companyid != '' &&
                    user.companyid != '0')
            ) {
                // bid success
                if (data.status != 'failed') {
                    if (didBulkBid) {
                        const bidIndex = bulkBidLineItems.findIndex((p) => {
                            return p.id === parseInt(data.id)
                        })
                        // bulk bid status messages
                        if (bidIndex !== -1) {
                            let bulkBidTemp = [...bulkBidLineItems]
                            bulkBidTemp[bidIndex].status = (
                                <td className="alert alert-success">{data.error}</td>
                            )
                            setBulkBidLineItems(bulkBidTemp)
                        }
                    }
                    // not the bulk bid
                    else {
                        const isCommonSubmitSuppressWindowActive =
                            commonSubmitSuppressSuccessUntil?.current > Date.now()
                        if (commonSubmitPendingSuccessAlerts?.current > 0) {
                            commonSubmitPendingSuccessAlerts.current -= 1
                            if (commonSubmitPendingSuccessAlerts.current <= 0) {
                                commonSubmitPendingSuccessAlerts.current = 0
                                if (commonSubmitSuppressSuccessUntil) {
                                    commonSubmitSuppressSuccessUntil.current = 0
                                }
                            }
                        } else if (!isCommonSubmitSuppressWindowActive) {
                            setAlert(
                                phrase['bid_placed_successfully'] || 'Bid placed successfully',
                                'success',
                            )
                        }
                    }

                    // update the company has bid variable
                    if (
                        data.bpop_companyid &&
                        data.bpop_companyid != '' &&
                        data.bpop_companyid != '0' &&
                        user.companyid &&
                        user.companyid != '' &&
                        user.companyid != '0'
                    ) {
                        lineItemsCopy[lineItemIndex].companyHasBid += 1
                    }
                    lineItemsCopy[lineItemIndex].hasBid = 1
                    setDwBidStatus(true)
                    lineItemsCopy[lineItemIndex].incrementAmt = data.bpop_cuser_increment
                    const currentUserNextBid = parseLineItemSocketInteger(data.bpop_cuser_nextbid)
                    if (currentUserNextBid !== null) {
                        lineItemsCopy[lineItemIndex].next_bid = currentUserNextBid
                    }
                    const socketBidStatus = String(data.bpop_bidstatus || '').toLowerCase()
                    const winningKey = String(phrase.winning || 'winning').toLowerCase()
                    const isSocketWinningStatus =
                        socketBidStatus.includes('winning') || socketBidStatus.includes(winningKey)
                    if (isUserHighestBidder || isSocketWinningStatus) {
                        if (lineItemsCopy[lineItemIndex].rprice > parseFloat(data.bpop_wprice)) {
                            lineItemsCopy[lineItemIndex].bidtopstatus = lineItemHighestBidderMessage
                        } else {
                            lineItemsCopy[lineItemIndex].bidtopstatus = lineItemWinningMessage
                        }
                    } else {
                        lineItemsCopy[lineItemIndex].bidtopstatus = data.bpop_bidstatus
                    }
                    lineItemsCopy[lineItemIndex].wprice = data.bpop_wprice
                    lineItemsCopy[lineItemIndex].bidPrice = data.cuser_enteramount
                    applyLineItemBidCount(lineItemsCopy[lineItemIndex])
                    setLineItems(lineItemsCopy)
                }
                // bid fail
                else {
                    if (didBulkBid) {
                        const bidIndex = bulkBidLineItems.findIndex((p) => {
                            return p.id === parseInt(data.id)
                        })
                        // bulk bid status messages
                        if (bidIndex !== -1) {
                            let bulkBidTemp = [...bulkBidLineItems]
                            bulkBidTemp[bidIndex].status = (
                                <td className="alert alert-danger">{data.error}</td>
                            )
                            setBulkBidLineItems(bulkBidTemp)
                        }
                    } else {
                        setAlert(data.error, 'error')
                    }
                }
            }
            // Other user bid on the item
            else {
                // Live (normal) line item
                if (lineItemsCopy[lineItemIndex].bidtype != 'sealed') {
                    lineItemsCopy[lineItemIndex].incrementAmt = data.bpop_increment
                    lineItemsCopy[lineItemIndex].wprice = data.bpop_wprice
                    const publicNextBid = parseLineItemSocketInteger(data.bpop_nextbid_org)
                    if (publicNextBid !== null) {
                        lineItemsCopy[lineItemIndex].next_bid = publicNextBid
                    }

                    // if this user / company has previously bid on this line item
                    if (
                        parseInt(lineItemsCopy[lineItemIndex].hasBid) > 0 ||
                        parseInt(lineItemsCopy[lineItemIndex].companyHasBid) > 0
                    ) {
                        // if this user / company is still the highest
                        if (
                            data.bpop_higher == user.id ||
                            (user.companyid == data.bpop_highercompanyid &&
                                data.bpop_highercompanyid &&
                                data.bpop_highercompanyid != '' &&
                                data.bpop_highercompanyid != '0' &&
                                user.companyid &&
                                user.companyid != '' &&
                                user.companyid != '0')
                        ) {
                            // reserve price not met yet
                            if (
                                lineItemsCopy[lineItemIndex].rprice > parseFloat(data.bpop_wprice)
                            ) {
                                lineItemsCopy[lineItemIndex].bidtopstatus =
                                    lineItemHighestBidderMessage
                            } else {
                                lineItemsCopy[lineItemIndex].bidtopstatus = lineItemWinningMessage
                            }
                            lineItemsCopy[lineItemIndex].bidPrice = data.bpop_wprice_morehigh
                        }
                        // outbid
                        else {
                            lineItemsCopy[lineItemIndex].bidtopstatus = lineItemLosingMessage
                        }
                    }
                }
                applyLineItemBidCount(lineItemsCopy[lineItemIndex])
                setLineItems(lineItemsCopy)
            }
        }
    }
    // AUCTION CLOSE
    else {
        let lineItemIndex = lineItems.findIndex((p) => {
            return p.id === parseInt(data.pid)
        })
        // this line item is on the page
        if (lineItemIndex !== -1) {
            let lineItemsCopy = [...lineItems]
            let wonMessage = `<div class="padboth" style="color: #28a745;"><strong>${phrase.won}</strong></div>`
            let lostMessage = `<div class="padboth" style="color: red;"><strong>${phrase.lost}</strong></div>`
            lineItemsCopy[lineItemIndex].isSocketUpdate = true
            // Awarded to someone
            if (data.usr != '') {
                lineItemsCopy[lineItemIndex].market_status = 'sold'
                // This User Won
                if (
                    data.usr == user.id ||
                    (user.companyid == data.cid &&
                        data.cid &&
                        data.cid != '' &&
                        data.cid != '0' &&
                        user.companyid &&
                        user.companyid != '' &&
                        user.companyid != '0')
                ) {
                    lineItemsCopy[lineItemIndex].bidtopstatus = wonMessage
                }
                // This user lost or did not bid
                else {
                    // Check if this user lost, then show message
                    if (
                        parseInt(lineItemsCopy[lineItemIndex].hasBid) > 0 ||
                        parseInt(lineItemsCopy[lineItemIndex].companyHasBid)
                    ) {
                        lineItemsCopy[lineItemIndex].bidtopstatus = lostMessage
                    }
                }
                setLineItems(lineItemsCopy)
            }
            // No winner
            else {
                lineItemsCopy[lineItemIndex].market_status = 'closed'
                // this user bid, but no winner, then show lost messages
                if (
                    parseInt(lineItemsCopy[lineItemIndex].hasBid) > 0 ||
                    parseInt(lineItemsCopy[lineItemIndex].companyHasBid)
                ) {
                    lineItemsCopy[lineItemIndex].bidtopstatus = lostMessage
                }
                setLineItems(lineItemsCopy)
            }
        }
    }
}
